import React from 'react';

const AustriaSpecificCompanyAddress = () => (
  <>
    <p>NIKE Retail B.V.</p>
    <p>Teinfaltstrasse 8/4</p>
    <p>1010 Vienna</p>
    <br />
  </>
);

export default AustriaSpecificCompanyAddress;
